import { z } from "zod";
/**
 * Partner invitation document — stored at `/partnerInvites/{token}` where the
 * document ID *is* the secret token (same shape idea as `/rsvpTokens`).
 *
 * The wedding owner creates one to invite a second person to co-plan. The
 * invitee opens `/invite/{token}`, signs in, and accepts — acceptance is three
 * client writes gated by `firestore.rules` (no Cloud Function). See
 * apps/web/src/features/partner/operations.ts.
 *
 * Timestamp fields arrive from Firestore as `Timestamp` objects at runtime, so
 * they are typed loosely here and read through the `toMillis` helper.
 */
export const PartnerInviteStatusSchema = z.enum(["pending", "accepted", "revoked"]);
export const PartnerInviteSchema = z.object({
    /** Mirrors the document id — the secret token. */
    token: z.string(),
    weddingId: z.string(),
    /** Owner uid — who sent the invite. */
    inviterId: z.string(),
    /** Couple display name, e.g. "Anna & Marek" — shown on the accept page. */
    inviterName: z.string(),
    /** Invitee email — always stored lowercased; the accept rule matches on it. */
    email: z.string().email(),
    weddingTitle: z.string(),
    /** ISO timestamp — display only. */
    weddingDate: z.string(),
    status: PartnerInviteStatusSchema.default("pending"),
    /** Uid of the user who accepted; null until then. */
    accepterId: z.string().nullable().optional(),
    /** When the invite was accepted (Firestore Timestamp). */
    acceptedAt: z.unknown().nullable().optional(),
    /** Firestore Timestamp — invite is dead after this; the accept rule enforces it. */
    expiresAt: z.unknown(),
    createdAt: z.unknown(),
    updatedAt: z.unknown(),
});
